import { breakpoints } from '../helpers/variables';

class SearchGen {
 breakpoint = window.matchMedia(
    `(max-width: ${breakpoints.tabletLandscape - 1}px)`
  );

  constructor() {
   this.init();
  }

   getLanguageCodeFromUrl() {
    const url = window.location.href;
    console.log('URLMard', url );
    const path = window.location.pathname;
    //console.log('Pathname', path );
    const pathSegments = path.split('/');
    //console.log('Segments', pathSegments );
    if (pathSegments.length > 1) {
      return pathSegments[1];
    }
    return null;
  }


  init() {
    const languageCode = this.getLanguageCodeFromUrl();

    if (languageCode === '/') {
      const script = document.createElement('script');
      script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=en_US';
      script.type = 'text/javascript';
      document.head.appendChild(script);
    } else if (languageCode === 'pt-br') {
      const script = document.createElement('script');
      script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=fr_FR';
      script.type = 'text/javascript';
      document.head.appendChild(script);
    } else if (languageCode === 'fr-fr') {
      const script = document.createElement('script');
      script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=pt_BR';
      script.type = 'text/javascript';
      document.head.appendChild(script);
    } 
    

  //   if (currentURL.includes("http://localhost:6006/iframe.html?viewMode=story&id=templates-home-page-default--default")) {
  //     const script = document.createElement('script');
  //     script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=fr_FR';
  //     script.type = 'text/javascript';
  //     document.head.appendChild(script);
  //   } else if (currentURL.includes("http://localhost:6006/iframe.html?viewMode=story&id=templates-home-page-variation--variation")) {
  //  const script = document.createElement('script');
  //     script.src = 'https://cloud.google.com/ai/gen-app-builder/client?hl=de_DE';
  //     script.type = 'text/javascript';
  //     document.head.appendChild(script);
  //   } else {
  //   // Default script behavior
  //   console.log("General page. Executing default script.");
  //   }
  }

}

export default SearchGen;